import { useHead } from '@vueuse/head';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default function usePageMeta({ pageTitle, pageDescription }: { pageTitle: string; pageDescription?: string; }) {
  const store = useStore();

  const SEO = computed(() => store.getters['seo/getSeo']);

  const description = SEO.value.description ?? pageDescription ?? pageTitle;
  const title = SEO.value.title ?? pageTitle ?? '';
  const meta: Record<string, string>[] = [{
    property: 'og:title',
    content: `${title && `${title} — `}Официальный интернет-магазин Funday`,
  }];

  if (description) {
    meta.push({
      name: 'description',
      content: description,
      vmid: 'description',
    });

    meta.push({
      property: 'og:description',
      content: description,
    });
  }

  useHead(
    {
      title,
      templateParams: {
        separator: '—',
        text: 'Официальный интернет-магазин Funday',
      },
      titleTemplate: '%s %separator %text',
      meta,
    },
    {
      mode: 'server',
    },
  );
}
